import { useTranslation } from 'react-i18next';

import NoPriceTap from 'lib/Tracking/Srp/SearchFilters/NoPriceTap';
import ExpandCollapseTap from 'lib/Tracking/Srp/SearchFilters/ExpandCollapseTap';
import { Features } from 'lib/EventSchema';
import useEvents from 'lib/hooks/useEvents';
import { usePriceFilter } from 'lib/hooks/useSrpFilters';

import FilterContainer from 'components/Shared/SearchFilter/FilterContainer';
import PageDivider from 'components/Shared/SearchFilter/PageDivider';
import Toggle from 'components/Shared/SearchFilter/Toggle';

import { useContext } from 'react';
import SrpEventContext from 'contexts/SrpEventContext';
import PriceInputSliderBlock from './PriceInputSliderBlock';

export interface PriceRangeFilterProps {
  expanded?: boolean;
}

export default function PriceRangeFilter(props: PriceRangeFilterProps): JSX.Element {
  const logger = useEvents();
  const { sourcePage } = useContext(SrpEventContext);
  const { value, setValue } = usePriceFilter();
  const { t } = useTranslation();

  const handleNoPriceChange = (isChecked: boolean): void => {
    logger.log(NoPriceTap({ sourcePage }));
    setValue({
      ...value,
      hideNoPriceListings: isChecked,
    });
  };

  return (
    <FilterContainer
      title={t('srp.filters.price.priceRange')}
      expanded={props.expanded}
      onClick={(isExpanding: boolean): Promise<void> =>
        logger.log(ExpandCollapseTap({ feature: Features.price, isExpanding, sourcePage }))
      }
    >
      <PriceInputSliderBlock />
      <PageDivider />
      <div className="no-price-toggle-container">
        <Toggle
          label={t('srp.filters.price.hideListings')}
          id="no-price-listings"
          onClick={handleNoPriceChange}
          isToggled={value.hideNoPriceListings}
        />
      </div>
      <style jsx>{`
        .no-price-toggle-container {
          margin: 4px 0;
        }
      `}</style>
    </FilterContainer>
  );
}
